import { OmitProps } from 'antd/lib/transfer/ListBody';
import React from 'react';
import { IoIosCloseCircle } from 'react-icons/io';
import styles from './chip.module.scss';

interface IChip {
  label: string;
  removable?: boolean;
  onRemove?: (person: string) => void;
  onRemoveId?: () => void;
  onClick?: () => void;
}

const CChip = (props: IChip) => {
  return (
    <div
      className={styles.wrapper}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
    >
      <p>{props.label}</p>
      {props.removable && (props.onRemove || props.onRemoveId) && (
        <IoIosCloseCircle
          onClick={() =>
            props.onRemoveId
              ? props.onRemoveId()
              : props.onRemove
              ? props.onRemove!(props.label)
              : null
          }
        />
      )}
    </div>
  );
};

export default CChip;
